import {action} from '@api'
import {SessionType} from '@modules/whiteboard'
import {BaseTool} from '@modules/whiteboard/tools/BaseTool'
import {TLBoundsCorner, TLPointerEventHandler, Utils} from '@tldraw/core'
import Vec from '@tldraw/vec'

export class FrameTool extends BaseTool {
  type = 'frame' as const

  /* ----------------- Event Handlers ----------------- */

  @action onPointerDown: TLPointerEventHandler = () => {
    const {
        app: {
          currentPoint: point, grid, patchCreate, tools: {startSession},
          ui: {currentPageId: parentId, currentStyle}, shapeUtils: {frame}
        },
      } = this,
      id = Utils.uniqueId(),
      newShape = frame.create({
        id,
        parentId,
        isGenerated: true,
        childIndex: 0, // It should always be in the back
        point: grid ? Vec.snap(point, grid) : point,
        style: {...currentStyle, strokeWidth: 1}
      })

    patchCreate([newShape])

    startSession(
      SessionType.TransformSingle,
      newShape.id,
      TLBoundsCorner.BottomRight,
      true
    )

    this.status = 'creating'
  }
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/tools/FrameTool/FrameTool.ts